/**
 * Expression validation state — shared by ExpressionPreview and master header.
 *
 * For Media Devoted | Created By Ciro Autiero
 */

import { validateFormula } from '@trafficpulse/shared';

export interface ExpressionPreviewState {
  isEmpty: boolean;
  isValid: boolean;
  error?: string;
}

export function evaluateExpressionState(expression: string): ExpressionPreviewState {
  const trimmed = expression.trim();
  if (!trimmed) return { isEmpty: true, isValid: false };
  try {
    validateFormula(trimmed);
    return { isEmpty: false, isValid: true };
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    return { isEmpty: false, isValid: false, error: message };
  }
}

export function expressionStatusLabel(state: ExpressionPreviewState): string {
  if (state.isEmpty) return 'empty';
  return state.isValid ? 'valid' : 'invalid';
}
